/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Given a function, returns a new function that will only run once
 */
export const once = <A extends any[], R, T>(
  fn: (this: T, ...arg: A) => R,
): ((this: T, ...arg: A) => R | undefined) => {
  let wasCalled = false
  return function (this: T, ...args: A) {
    if (wasCalled) {
      return
    }
    wasCalled = true
    return fn.apply(this, args)
  }
}
